"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var FavoriteFill_exports = {};
__export(FavoriteFill_exports, {
  default: () => FavoriteFill_default
});
module.exports = __toCommonJS(FavoriteFill_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.42578 16.4805H9.40625C8.44271 15.5951 7.57031 14.7812 6.78906 14.0391C5.99479 13.2839 5.31771 12.5612 4.75781 11.8711C4.19792 11.181 3.76172 10.4974 3.44922 9.82031C3.14974 9.15625 3 8.46615 3 7.75C3 7.16406 3.10417 6.61719 3.3125 6.10938C3.53385 5.60156 3.82682 5.16536 4.19141 4.80078C4.56901 4.42318 5.00521 4.1237 5.5 3.90234C6.00781 3.69401 6.54818 3.58984 7.12109 3.58984C7.77214 3.58984 8.39714 3.73307 8.99609 4.01953C9.59505 4.30599 10.0964 4.6901 10.5 5.17188C10.9036 4.6901 11.4049 4.30599 12.0039 4.01953C12.6029 3.73307 13.2279 3.58984 13.8789 3.58984C14.4518 3.58984 14.9922 3.69401 15.5 3.90234C15.9948 4.1237 16.4245 4.42318 16.7891 4.80078C17.1667 5.16536 17.4661 5.60156 17.6875 6.10938C17.8958 6.61719 18 7.16406 18 7.75C18 8.46615 17.8503 9.15625 17.5508 9.82031C17.2383 10.4974 16.8021 11.181 16.2422 11.8711C15.6823 12.5612 15.0052 13.2839 14.2109 14.0391C13.4297 14.7943 12.5573 15.6146 11.5938 16.5C11.2812 16.7734 10.9167 16.9102 10.5 16.9102C10.0833 16.9102 9.72526 16.7669 9.42578 16.4805Z",
      fill: "currentColor"
    }
  )
);
const SvgFavoriteFill = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var FavoriteFill_default = SvgFavoriteFill;
